import React from "react";
import { useTranslation } from "react-i18next";
import { SEVERITY_CONFIG } from "util/cxAlertModel";
import cxStyles from "./cxAlert.module.scss";

export default function AlertSeverityBadge({ severity, showIcon = true }) {
  const { t } = useTranslation();
  if (!severity || !SEVERITY_CONFIG[severity]) return null;
  const config = SEVERITY_CONFIG[severity];
  return (
    <span
      className={`${cxStyles.severityBadge} ${cxStyles[config.className]}`}
    >
      {showIcon ? `${config.icon} ` : ""}
      {t(config.labelKey)}
    </span>
  );
}
